export default __webpack_public_path__ + "static/media/add.5affbf4b.svg";